import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { STATIC_BOTTOM_PAGES_LINK} from '../static-content';
import { forgotPassword } from '../store/actions/auth';
import LoginModal from '../modals/login';
import ForgotPassword from '../modals/forgotPassword';
import RegisterModal from '../modals/register';
import RequestBrandModal from '../modals/requestBrand';
import FollowMeExistUserModal from '../modals/followMeExistingUser';
import FollowMeNewUserModal from '../modals/followMeNewUser';
import AgencyNewUserModal from '../modals/agencyNewUser';
import DeleteAccountModal from '../modals/deleteAccount';
import {Elements} from 'react-stripe-elements';
import Moment from "react-moment"
class Footer extends Component {
  render() {
    return (
      <Fragment>
        <footer className="bg-light">
        <div className="container">
            <div className="row">
                <div className="f-items">
                    <div className="col-md-12 col-sm-12 equal-height item">
                        <div className="f-item link">
                            <ul>
                                {
                                  STATIC_BOTTOM_PAGES_LINK.map((link, i) => (
                                    <li key={i}>
                                      <Link to={link.route} >
                                          {link.text}
                                      </Link>
                                    </li>
                                  ))
                                }
                                <li>
                                  <a  data-toggle="modal" data-target="#guarantee">Fitbanx Guarantee</a>
                              </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="col-md-12 text-center">
                            <p>&copy; Copyright <Moment format="YYYY">{new Date()}</Moment>. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <div className="modal fade" id="login" role="dialog">
           <LoginModal {...this.props}/>
    </div>
    <div className="modal fade" id="freedownload" role="dialog">
        <Elements>
          <RegisterModal {...this.props}/>
        </Elements>
   </div>
    <div className="modal fade" id="forgotPassword" role="dialog">
           <ForgotPassword {...this.props}/>
   </div>
   <div className="modal fade" id="alreadyFitbanx" role="dialog">
        <FollowMeExistUserModal {...this.props} openPaymentForm={this.props.openPaymentForm}/>
  </div>
  <div className="modal fade" id="enroll" role="dialog">
      <Elements>
        <FollowMeNewUserModal {...this.props}/>
      </Elements>
   </div>
   <div className="modal fade" id="enrollTrainer" role="dialog">
      <Elements>
        <AgencyNewUserModal {...this.props} isNCEP={this.props.isNCEP}/>
      </Elements>
   </div>
   <div className="modal fade" id="myModal2" role="dialog">
        <RequestBrandModal {...this.props}/>
   </div>

   <div className="modal fade" id="openInMobile" role="dialog">
     <div className="modal-dialog">
       <div className="modal-content">
         <div className="modal-header">
           <button type="button" className="close" data-dismiss="modal">&times;</button>
           <h3>Access our creative exercises and workouts in the Fitbanx app.</h3>
         </div>
         <div  className="modal-body">
            <p>The app is only available on your mobile device. Please open the link on your mobile phone to download the app and access our creative exercises and workouts! Please email <a href="mailto:support@fitbanx.com">support@fitbanx.com</a> for any questions.</p>
          </div>
         <div className="modal-footer">
           <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
         </div>
       </div>
     </div>
   </div>

   <div className="modal fade" id="deleteAccount" role="dialog">
        <DeleteAccountModal {...this.props}/>
     </div>

   <div className="modal fade" id="guarantee" role="dialog">
     <div className="modal-dialog">
       <div className="modal-content">
         <div className="modal-header">
           <button type="button" className="close" data-dismiss="modal">&times;</button>
           <h3>The Fitbanx no risk, no hassle 60- day guarantee</h3>
         </div>
         <div style={{'padding':'50px'}} className="modal-body">
            <p>Fitbanx software for trainers, coaches, and fitness brands comes with a 100% money back guarantee...but we don’t stop there. You will see how easy it is to build and share workouts with your clients, fans, and followers. Your customers will be thrilled to access YOUR creative  workouts on their mobile phones that DO NOT depend on YouTube or slow streaming videos. There’s a good reason Fitbanx is known for building and sharing digital workouts easily. Here’s a note from the founder of Fitbanx himself:</p>
       <p>"I take your fitness business seriously and you have my personal promise that Fitbanx will allow you to enter the digital workout marketplace easily and affordably.  It is my goal for you to increase your profits and create recurring monthly revenue by sharing your knowledge and workout creativity with your customers, fans, and followers. I believe in the Fitbanx platform so much, I guarantee it for a full 60 days."- Todd Bossier, President and Founder</p>
       <p>At anytime during your first 60 days, if you decide Fitbanx hasn't performed on the promise of allowing you to build and share digital workouts easily, just email us at <a href="mailto:guarantee@Fitbanx.com">guarantee@Fitbanx.com</a>​ and let us know that you want a refund...and we will give you a complete refund for up to 60 days.</p>
       <p>If you aren’t satisfied, we would not feel right about keeping your money, so we make it easy to get a refund.  We will pay you via Paypal or Venmo...or we will mail you a check. And just to be clear,there are absolutely no strings attached, no forms to fill out, nothing to prove and we promise we won’t question you. ​<b>We won't even ask for any money back that you may have made by using Fitbanx.</b> And you won’t have to wait either, we will issue a refund within 24 hours. You’ll be pleased with what we do for you or we will make it right, guaranteed!</p>
         </div>
         <div className="modal-footer">
           <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
         </div>
       </div>
     </div>
   </div>
   </Fragment>
    )
  }
}

export default connect(null, { forgotPassword })(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js